<template>
  <BaseElFormItem v-bind="$attrs">
    <template #label>
      <div class="form-item-tooltip-lable" style="gap: 8px">
        <p class="text-normal">{{ label }}</p>
        <slot name="subTitle" />
        <el-tooltip placement="right">
          <div slot="content" :style="tooltipWidth ? `width: ${tooltipWidth}px` : ''">
            <slot name="tooltip-content">
              {{ tooltip }}
            </slot>
          </div>
          <MaterialIcon v-if="!hideIcon" :size="iconSize">help_outline</MaterialIcon>
        </el-tooltip>
      </div>
    </template>
    <slot />
  </BaseElFormItem>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FormItemTooltip',
  props: {
    label: String,
    tooltip: String,
    tooltipWidth: { type: [String, Number] },
    iconSize: { type: Number, default: 24 },
    hideIcon: Boolean,
  },
  setup (props) {
    return {}
  },
})
</script>

<style lang="postcss" scoped>
.form-item-tooltip-lable {
  @apply items-center !inline-flex;
}
</style>
